<script setup lang="ts">
import ILxcInfo from "~icons/lxc/info";

const { t } = useI18n();
</script>

<template>
  <lxc-alert type="gray" :icon="ILxcInfo"
    ><slot name="default">{{ t("message.noData") }}</slot></lxc-alert
  >
</template>
